<template>
	<div class="settings">
		<el-card v-if="user" :body-style="{ padding: 0 }">
			<div slot="header" class="header">
				<!-- <el-button style="float:right;margin:-8px;-8px" type="danger">Add Two-Factor Authentication</el-button> -->
				<el-button v-if="user.phone" class="right" type="success" plain>
					<i class="el-icon-phone"></i>
					{{ formattedPhone }}
				</el-button>

				<el-button v-else @click="togglePhone" class="right" type="danger" plain>
					<i class="el-icon-phone"></i>
					Add Phone
				</el-button>

				<h3>{{ user.name }}</h3>
				<p>{{ user.email }}</p>
			</div>
			<!-- <div class="form">
			  <el-input placeholder="Please input" v-model="currentName">
				<template v-if="changedName" slot="append">
					<el-button type="success" @click="nameChange">
						Update Name
					</el-button>
				</template>
			  </el-input>
			</div>
			<div class="form">
			  <el-input placeholder="Please input" v-model="currentEmail">
				<template v-if="changedEmail" slot="append">
					<el-button type="success" @click="emailChange">
						Change Email
					</el-button>
				</template>
			  </el-input>
			</div> -->
			<div class="footer">
				<div>
					<el-button type="link" @click="openNameChange">Change Name</el-button>
					<el-button type="link" @click="openEmailChange">Change Email</el-button>
					<el-button type="link" @click="openPasswordChange">Change Password</el-button>
					<el-button type="link" v-if="! user.phone" @click="openPhoneChange">Change Phone Number</el-button>
					<el-button type="link" @click="openContact" style="float:right">Contact Support</el-button>
				</div>
			</div>
			<!-- TODO:
			<div v-bind:is="formElement(currentForm)"
				@change="changeForm"
				@cancel="cancel(currentForm)">
			</div>
			-->
			<!-- <template v-if="showNameForm">
				<ChangeName @change="nameChange" @cancel="cancel('showNameForm')" class="change-field">
				</ChangeName>
			</template>
			<template v-if="showEmailForm">
				<ChangeEmail @change="emailChange" @cancel="cancel('showEmailForm')" class="change-field">
				</ChangeEmail>
			</template>
			<template v-if="showPasswordForm">
				<ChangePassword @change="passwordChange" @cancel="cancel('showPasswordForm')" class="change-field">
				</ChangePassword>
			</template>
			<template v-if="showPhoneForm">
				<ChangePhone @change="phoneChange" @cancel="cancel('showPhoneForm')" class="change-field">
				</ChangePhone>
			</template>
			<template v-if="showContactForm">
				<ContactSupport @submit="contactSupport" @cancel="cancel('showContactForm')" class="change-field">
				</ContactSupport>
			</template>
			<template v-if="showAddPhoneForm">
				<AddPhone @change="phoneAdd" @cancel="cancel('showAddPhoneForm')" class="change-field">
				</AddPhone>
			</template> -->
		</el-card>
		<br>
		<el-card v-if="user">
			<div slot="header" class="header">
				<el-button class="right" size="small" type="success">Save Changes</el-button>
				<h4>Edit profile</h4>
			</div>
			<el-form label-position="right" label-width="100px">
			  <el-form-item label="Full Name">
			    <el-input v-model="user.name"></el-input>
			  </el-form-item>
			  <el-form-item label="Profile Image">
				  <el-upload drag
				  action=""
				  class="image-upload"
				  :show-file-list="false"
				  :before-upload="uploadImage">
				  <img v-if="imageUrl" :src="imageUrl" class="image">
				  <template v-else>
				  	<i class="el-icon-upload"></i>
				  	<!-- <div class="el-upload__text">Drop file here or <em>click to upload</em></div> -->
				</template>
				</el-upload>
			  </el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ChangePassword from './component/ChangePassword'
import ChangeEmail from './component/ChangeEmail'
import ChangeName from './component/ChangeName'
import AddPhone from './component/AddPhone'
import ChangePhone from './component/ChangePhone'
import ContactSupport from './component/ContactSupport'

export default {
	name: 'user-settings',

	data() {
		return {
			uploading: null,
			currentForm: 'name',
			currentName: null,
			currentEmail: null,
			currentPhone: null,
			currentSupport: null,
			showEmailForm: false,
			showPasswordForm: false,
			showAddPhoneForm: false,
			showPhoneForm: false,
			showNameForm: false,
			showContactForm: false,
			imageUrl: 'https://cdn.doctorbox.com/user/undefined/keshav.png'
		}
	},

	watch: {
		user(user) {
			if (this.currentName == null)
				this.currentName = user.name
			if (this.currentEmail == null)
				this.currentEmail = user.email
		}
	},

	methods: {
		...mapActions(['upload']),
		...mapActions('auth',[
			'changeEmail',
			'changePassword',
			'addPhone',
			'phoneChange'
		]),
		...mapActions('user',[
			'sendSupport'
		]),
		formElement(form) {
			if (form == 'name')
				return 'ChangeName'
		},

		update() {

		},
		uploadImage(file) {
			const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg')
			const isPNG = (file.type === 'image/png')
	        const isLt2M = file.size / 1024 / 1024 < 2

	        if (!isJPG && ! isPNG) {
	          // this.$message.error('Avatar picture must be JPG format!');
	        }
	        if (!isLt2M) {
	          // this.$message.error('Avatar picture size can not exceed 2MB!');
	        }
	        if ((isJPG || isPNG) && isLt2M) {
				this.uploading = file

				this.upload({
					file: file
				})
				.then((response) => {
					this.uploading = null
					console.log('upload response', response)
				})
				.catch((error) => {
					this.uploading = null
					console.log('upload failure', error)
				})
			}
		},

		success(res, file) {
			this.imageUrl = URL.createObjectURL(file.raw);
		},
		openNameChange() {
			this.showNameForm = true
			this.showEmailForm = false
			this.showPasswordForm = false
			this.showAddPhoneForm = false
			this.showContactForm = false
			this.showPhoneForm = false
		},
		openEmailChange() {
			this.showNameForm = false
			this.showEmailForm = true
			this.showPasswordForm = false
			this.showAddPhoneForm = false
			this.showContactForm = false
			this.showPhoneForm = false
		},
		openPasswordChange() {
			this.showNameForm = false
			this.showEmailForm = false
			this.showPasswordForm = true
			this.showAddPhoneForm = false
			this.showContactForm = false
			this.showPhoneForm = false
		},
		openPhoneChange() {
			this.showNameForm = false
			this.showEmailForm = false
			this.showPasswordForm = false
			this.showAddPhoneForm = false
			this.showContactForm = false
			this.showPhoneForm = true
		},
		openContact() {
			this.showNameForm = false
			this.showEmailForm = false
			this.showPasswordForm = false
			this.showAddPhoneForm = false
			this.showContactForm = true
			this.showPhoneForm = false
		},
		togglePhone() {
			this.showNameForm = false
			this.showEmailForm = false
			this.showPasswordForm = false
			this.showAddPhoneForm = true
			this.showContactForm = false
			this.showPhoneForm = false
		},
		nameChange({ name }) {
			this.updateUser({
				name: name
			})
			.then((result) => {
				return
			})
		},
		emailChange({ email }) {
			this.changeEmail({
				email: email ? email : this.currentEmail
			})
			.then((result) => {
				return
			})
		},
		passwordChange({ origPassword, newPassword}) {
			this.changePassword({
				password: origPassword,
				new_password: newPassword
			})
			.then((result) => {
				return
			})
		},
		phoneChange({ newPhone }) {
			this.changePhone({
				phone: newPhone
			})
			.then((result) => {
				return
			})
		},
		phoneAdd({ phone }) {
			this.addPhone({
				phone: phone
			})
			.then((result) => {
				return
			})
		},
		contactSupport({ support }) {
			this.sendSupport({
				question: support
			})
			.then((result) => {
				return
			})
		},
		cancel(status) {
			this[status] = false
		}
	},

	computed: {
		...mapState('user', [
			'user'
		]),
		...mapGetters(['getUploadProgress']),
		uploadProgress() {
			return this.getUploadProgress(this.uploading)
		},
		changedName() {
			return this.currentName != this.user.name
		},
		changedEmail() {
			return this.currentEmail != this.user.email
		},
		formattedPhone() {
			var phone = this.user.phone.substring(2, this.user.phone.length)
			return phone.substring(0,3) + '-' + phone.substring(3,6) + '-' + phone.substring(6, 10)
		}
	},
    components: {
		ChangePassword,
		ChangeEmail,
		ChangeName,
		AddPhone,
		ChangePhone,
		ContactSupport
    }
}
</script>

<style lang="scss" scoped>
.settings {
	padding: 10px;
	background: #fafafa;

	.el-card {
		max-width: 1100px;
		.form {
			padding: 15px 20px;
			.el-input-group__append button.el-button {
				color: #44B358;
				background: #ecf7ee;
				border: none;
			}
			.el-input-group__append button.el-button:hover {
				background-color: #44B358;
				border-color: #44B358;
				color: white;
			}
		}
		.footer {
			border-top: 1px solid #EBEEF5;
			padding: 15px 20px;
		}
		.change-field {
		}
	}
	.image-upload {
		// border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
		width: 300px;
	}
	.image {
		height: 200px;
		// float: right;
	}

	.right {
		float:right;
		margin:-8px;
	}
}
</style>
